export default __webpack_public_path__ + "static/media/1039.aa0e54d6.png";